import {
  SET_PERSONAL_LIST,
  SET_ENTERPRISE_LIST,
  SET_PROJECT_LIST,
  SET_FILTER_DATA,
  SET_WORKSPACE
} from './mutation-types.js'

export default {
  [SET_PERSONAL_LIST] (state, personalList) {
    state.personalList = personalList
  },
  [SET_ENTERPRISE_LIST] (state, enterpriseList) {
    state.enterpriseList = enterpriseList
  },
  [SET_PROJECT_LIST] (state, projectList) {
    state.projectList = projectList
  },
  [SET_FILTER_DATA] (state, filterData) {
    state.filterData = filterData
  },
  // x. 将登录用户 拥有的空间 存放在store中
  [SET_WORKSPACE] (state, data) {
    let obj = {
      // 1: '', // 个人空间/员工资料库
      // 2: '', // 共享空间
      // 3: '' // 项目库
    }
    Object.assign(obj, data || {})
    // console.log(obj)
    state.workspace = obj
    state.workspaceReady = true
  }
}

